// src/components/layout/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../common/Sidebar';
import Header from '../common/Header';

const Layout = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const newIsMobile = window.innerWidth <= 768;
            if (newIsMobile !== isMobile) {
                setIsMobile(newIsMobile);
                setMobileOpen(false);
                setSidebarCollapsed(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobile]);

    const toggleSidebar = () => {
        if (isMobile) {
            setMobileOpen(!mobileOpen);
        } else {
            setSidebarCollapsed(!sidebarCollapsed);
        }
    };

    const closeMobileSidebar = () => {
        if (isMobile) {
            setMobileOpen(false);
        }
    };

    return (
        <div className="layout">
            {/* Sidebar Backdrop for mobile */}
            <div
                className={`sidebar-backdrop ${mobileOpen ? 'mobile-open' : ''}`}
                onClick={closeMobileSidebar}
            />

            {/* Sidebar */}
            <Sidebar
                collapsed={sidebarCollapsed}
                mobileOpen={mobileOpen}
                onNavigate={closeMobileSidebar}
            />

            {/* Main Content */}
            <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
                <Header onToggleSidebar={toggleSidebar} />

                <main className="page-content">
                    <Outlet />
                </main>
            </div>

            <style jsx>{`
        .layout {
          min-height: 100vh;
          background: var(--light-color);
        }

        .main-content {
          margin-left: 280px;
          transition: all var(--transition-normal);
          min-height: 100vh;
        }

        .main-content.expanded {
          margin-left: 70px;
        }

        .page-content {
          min-height: calc(100vh - 80px);
        }

        .sidebar-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.5);
          z-index: 999;
          opacity: 0;
          visibility: hidden;
          transition: all var(--transition-normal);
        }

        .sidebar-backdrop.mobile-open {
          opacity: 1;
          visibility: visible;
        }

        @media (max-width: 768px) {
          .main-content {
            margin-left: 0;
          }

          .main-content.expanded {
            margin-left: 0;
          }
        }
      `}</style>
        </div>
    );
};

export default Layout;